/**
 * Component: Suite Info
 */
(() => {
  const GROUP_SIZE_CHANGE_EVENT = 'group-size:change';
  const SUITE_WORD = 'suites';
  const GUEST_WORD = 'guests';

  class ProductSuiteInfo extends HTMLElement {
    constructor() {
      super();
      this.textElement = this.querySelector('.suite-info__text');
      this.fieldset = this.closest('.variant-input-wrapper');
    }

    connectedCallback() {
      if (!this.textElement || !this.fieldset) return;

      this.radios = Array.from(this.fieldset.querySelectorAll('input[type="radio"]'));
      if (!this.radios.length) return;

      this.fieldset.addEventListener('change', this.handleSuiteChange.bind(this));

      this.groupSizeInput = (this.closest('.product__info-wrapper') || document).querySelector('[name="group_size"]');
      if (this.groupSizeInput) {
        this.groupSize = parseInt(this.groupSizeInput.value, 10) || 0;
        this.groupSizeChangeHandler = this.handleGroupSizeChange.bind(this);
        document.addEventListener(GROUP_SIZE_CHANGE_EVENT, this.groupSizeChangeHandler);
      }

      this.update();
    }

    disconnectedCallback() {
      if (this.groupSizeChangeHandler) {
        document.removeEventListener(GROUP_SIZE_CHANGE_EVENT, this.groupSizeChangeHandler);
      }
    }

    get selectedRadio() {
      return this.radios.find((radio) => radio.checked) || null;
    }

    getRecommendedRadio() {
      const withinBand = this.radios.find((radio) => {
        const max = parseInt(radio.dataset.suiteMax, 10);
        return Number.isFinite(max) && this.groupSize <= max;
      });
      if (withinBand) return withinBand;

      const openEnded = this.radios.find((radio) => !radio.dataset.suiteMax);
      return openEnded || this.radios[this.radios.length - 1];
    }

    labelFor(radio) {
      return this.fieldset.querySelector(`label[for="${radio.id}"]`);
    }

    handleSuiteChange(event) {
      if (event.target.type !== 'radio') return;
      this.update();
    }

    handleGroupSizeChange(event) {
      const value = parseInt(event.detail.value, 10);
      if (!Number.isFinite(value)) return;
      this.groupSize = value;
      this.update();
    }

    update() {
      if (!this.groupSizeInput) {
        this.renderStatic();
        return;
      }

      const recommended = this.getRecommendedRadio();
      const selected = this.selectedRadio;
      this.renderBadge(recommended);

      if (selected && selected === recommended) {
        this.renderText(`${selected.value} ${SUITE_WORD} — ${selected.dataset.suiteRecommendation}`);
      } else if (recommended) {
        this.renderText(`For ${this.groupSize} guests we recommend ${recommended.value} ${SUITE_WORD}.`);
      }
    }

    renderStatic() {
      const selected = this.selectedRadio;
      const recommendation = selected ? selected.dataset.suiteRecommendation : '';
      if (!recommendation) {
        this.hidden = true;
        return;
      }
      this.renderText(`${selected.value} ${SUITE_WORD} — ${recommendation}`);
    }

    renderBadge(recommended) {
      const badgeText = `Recommended for ${this.groupSize} ${GUEST_WORD}`;
      this.radios.forEach((radio) => {
        const label = this.labelFor(radio);
        if (!label) return;

        const wrapper = label.querySelector('[data-suite-recommend]');
        const isRecommended = radio === recommended;
        if (wrapper) wrapper.hidden = !isRecommended;

        if (isRecommended) {
          label.dataset.tooltip = badgeText;
          const screenReaderLabel = wrapper ? wrapper.querySelector('[data-suite-recommend-sr]') : null;
          if (screenReaderLabel) screenReaderLabel.textContent = badgeText;
        } else {
          delete label.dataset.tooltip;
        }
      });
    }

    renderText(text) {
      this.hidden = false;
      this.textElement.textContent = text;
    }
  }

  customElements.define('product-suite-info', ProductSuiteInfo);
})();
